exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".alert{max-height:200px;overflow:hidden;transition:1s ease-in-out;will-change:max-height,opacity}.alert.error{background:#e03c3c;color:#fff}.alert.success{background:#41b883;color:#fff}.alert.enter,.alert.exit{max-height:0}.alert p{width:480px;margin:0 auto;padding:4px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/Alert.scss
// module id = 125
// module chunks = 0